import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../shared/Card';
import FloorPlanUpload from '../../shared/FloorPlanUpload';
import ImagePreview from '../../shared/ImagePreview';
import { Col, Row } from 'reactstrap';
import ImageCompressor from 'compressorjs';
import { MAX_SIZE, MAX_FLOOR_PLAN_SIZE } from '../../../constants/FloorPlan';

class FloorPlan extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  static get propTypes() {
    return {
      edit: PropTypes.bool,
      files: PropTypes.array,
      imagesUrls: PropTypes.array,
      onLoad: PropTypes.func,
      onClear: PropTypes.func,
      showErrorWindow: PropTypes.func,
    };
  }

  compressImage(file) {
    return new Promise((resolve, reject) => {
      new ImageCompressor(file, {
        quality: 0.8,
        maxWidth: 1000,
        maxHeight: 1000,
        success: resolve,
        error: reject,
      });
    });
  }

  onDrop(files, rejectedFiles = []) {
    const { onLoad, showErrorWindow } = this.props;
    const rejectedFile = rejectedFiles[0];

    if (rejectedFile) {
      showErrorWindow();
      return;
    }

    files.forEach((file) => {
      if (file.size > MAX_FLOOR_PLAN_SIZE && file.type !== 'application/pdf') {
        this.compressImage(file).then((compressImage) => {
          compressImage.preview = file.preview;
          onLoad(compressImage);
        });
      } else {
        onLoad(file);
      }
    });
  }

  onClear(index) {
    this.props.onClear(index);
  }

  render() {
    const { edit, files, imagesUrls } = this.props;

    return (
      <Card header="Floor Plan">
        <Choose>
          <When condition={edit}>
            <FloorPlanUpload
              urls={imagesUrls}
              onDrop={this.onDrop}
              onClear={(index) => this.onClear(index)}
              files={files}
              showIcon={false}
              isTestImages={true}
              maxSize={MAX_SIZE}
            />
          </When>
          <Otherwise>
            <div className="text-center">
              <Row>
                {imagesUrls.map((imageUrl, index) => (
                  <Col key={index}>
                    <Choose>
                      <When condition={files[index] && files[index].type === 'application/pdf'}>
                        <div>{files[index].name}</div>
                      </When>
                      <Otherwise>
                        <ImagePreview src={imageUrl ? imageUrl : null} />
                      </Otherwise>
                    </Choose>
                  </Col>
                ))}
              </Row>
            </div>
          </Otherwise>
        </Choose>
      </Card>
    );
  }
}

export default FloorPlan;



// WEBPACK FOOTER //
// src/components/testDetails/FloorPlan/index.jsx